import { StreamType } from './types';
export const reduxKey = '@@streams';
export const actionKey = 'STREAM';
export const defaultStreamState = {
    streamId: '',
    streamType: StreamType.WITH_CURSOR,
    items: [],
    itemsPerFetch: 0,
    hasMore: false,
    hasLess: false
};

//# sourceMappingURL=constants.js.map